import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';

import { Modal, BSModalContext } from 'angular2-modal/plugins/bootstrap';
import { overlayConfigFactory } from 'angular2-modal';

import { StatusModalComponent } from './modals/status/status-modal.component';
import { SharedClientService } from '../../../client/shared/services/shared-client.service';
import { FileHelper } from '../../../../providers/file.service';
import { AuthService } from '../../../../providers/auth.service';

import { NavbarStatisticsState } from './store/navbar-statistics-state';
import { NavbarStatisticsStateService } from './store/navbar-statistics-state.service';
import { SharedInterviewService } from '../../../client/shared/services/shared-interview.service';
import { PosthogService } from '../../../../providers/posthog.service';

declare var window: any;
declare var $: any;


export class NavbarClientComponent implements OnInit, OnDestroy {
	public navbarStatisticsState: NavbarStatisticsState = {
		loading: true,
		requireActionInterviewsCount: 0
	};

	public client: any;
	public hjClientApp = process.env.CLIENT_APP_URL;

	public latestBillingState: any;

	public fallbackClientLogo = false;
	public permissions: any;
	public eventsSubscription: Subscription;
	private clientActionsSubscription: Subscription;
	private navbarStatisticsSubscription: Subscription;

	private loadingPermissions: boolean;

	constructor(
		public modal: Modal,
		private sharedClientService: SharedClientService,
		private fileHelper: FileHelper,
		private authService: AuthService,
		private posthogService: PosthogService,
		private navbarStatisticsStateService: NavbarStatisticsStateService,
		private sharedInterviewService: SharedInterviewService) { }

	// Lifecycle Hooks
	public ngOnInit() {
		this.permissions = this.authService.clientPermissions;
		this.getClient();
		this.subscribeToNavbarStatisticsState();
		this.getNavbarStatistics();
		this.eventsSubscription = this.sharedClientService.emitEventAction$.subscribe(
			(action) => {
				this.fetchEventAction(action);
			}
		);
	}

	public ngOnDestroy(): void {
		if (this.eventsSubscription) {
			this.eventsSubscription.unsubscribe();
		}
		if (this.clientActionsSubscription) {
			this.clientActionsSubscription.unsubscribe();
		}
		if (this.navbarStatisticsSubscription) {
			this.navbarStatisticsSubscription.unsubscribe();
		}
	}

	public onLogOutClick($event: any): void {
		$event.preventDefault();
		this.posthogService.logout();
		this.authService.logout();
	}

	public getUrl(file?: string) {
		if (file) {
			return this.fileHelper.rewriteUrl(file);
		}
	}

	public logoPlaceholder() {
		this.fallbackClientLogo = true;
	}

	public openMobileSubmenu(event) {
		event.currentTarget.parentElement.classList.add('open');
	}

	public closeMobileSubmenu(event) {
		event.currentTarget.parentElement.lastChild.previousSibling.classList.remove('open');
	}

	private subscribeToNavbarStatisticsState() {
		this.navbarStatisticsSubscription = this.navbarStatisticsStateService.$state.subscribe((state) => {
			this.navbarStatisticsState = state;
		});
	}

	// Services
	private getNavbarStatistics() {
		const interviewsFilterParams = {
			'owner_id': this.authService.userId.toString(),
			'statuses[]': ['require-action']
		};
		this.sharedInterviewService.getApplicationStages(interviewsFilterParams).subscribe((res) => {
			this.navbarStatisticsStateService.setRequireActionInterviewsCount(res.length);
		});
	}

	private getClient(update?: boolean) {
		this.sharedClientService.get(this.authService.userId).subscribe(
			(client) => {
				this.client = client;
				let restrictedStatuses = ['past-client|nurture', 'past-client|cold', 'past-client|warm', 'past-client|not-interested'];
				if (restrictedStatuses.indexOf(this.client.status) !== -1) {
					this.initStatusModal();
				} else {
					this.getBillingState();
				}
			}
		);
	}

	private reloadClientPermissions() {
		this.loadingPermissions = true;
		this.sharedClientService.getPermissions(String(this.authService.userId)).subscribe(
			(clientPermissions) => {
				this.authService.setClientPermissions(clientPermissions);
				this.loadingPermissions = false;
			},
			() => {
				this.loadingPermissions = false;
			}
		);
	}

	private getBillingState() {
		this.sharedClientService.getLatestBillingState(String(this.authService.userId)).subscribe(
			(latestBillingState) => {
				this.latestBillingState = latestBillingState;
			},
			(error) => {
				if (error.status === 404) {
					this.latestBillingState = null;
				}
			}
		);
	}

	// Helpers
	private initStatusModal(): void {
		let data: any = {
			client: this.client
		};
		let modalSettings: any = {
			dialogClass: 'status-modal',
			isBlocking: true,
			size: 'lg',
			keyboard: 1000,
			statusData: data
		};
		this.modal.open(StatusModalComponent, overlayConfigFactory(modalSettings, BSModalContext))
			.then((result) => { result.result.then(
			() => {
				this.getBillingState();
			},
			() => {
				this.getBillingState();
			});
		});
	}

	private fetchEventAction(action: any) {
		switch (action) {
			case 'getClient':
				this.getClient(true);
				break;

			case 'reloadClientPermissions':
				if (!this.loadingPermissions) {
					this.reloadClientPermissions();
				}
				break;

			default:
				break;
		}
	}
static ctorParameters() { return [ { type: Modal }, { type: SharedClientService }, { type: FileHelper }, { type: AuthService }, { type: PosthogService }, { type: NavbarStatisticsStateService }, { type: SharedInterviewService } ]; }}



// WEBPACK FOOTER //
// ./node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/components/shared/navbar/client/navbar-client.component.ts